import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  table: {
    minWidth: 650,
  },
  tableContainer: {
    margin: 15,
  },
  tableRow: {
    cursor: 'pointer',
  },
  searchFormControl: {
    margin: 8,
    width: '100%',
  },
  sortIcon: {
    '& svg': {
      opacity: '100',
      top: '0px !important',
    },
  },
}));
